import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "danger";

// Mirrors TradeBo's button primitives: pill shape, 600 weight, a purple glow on
// the primary and a quiet outline on the secondary.
const styles: Record<Variant, string> = {
  primary:
    "bg-brand text-white shadow-glow hover:bg-brand-dark disabled:bg-brand/40 disabled:shadow-none",
  secondary:
    "border border-slate-200 bg-white text-slate-800 hover:border-brand-light hover:text-brand",
  danger:
    "bg-accent-dark text-white shadow-glow-pink hover:bg-accent disabled:bg-accent/40 disabled:shadow-none",
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
}

export function Button({
  variant = "primary",
  loading,
  className = "",
  children,
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-pill px-[18px] py-[11px] text-sm font-semibold leading-none transition disabled:cursor-not-allowed ${styles[variant]} ${className}`}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? "Please wait…" : children}
    </button>
  );
}
